import Vue from "vue"
import store from "@/store"

// Plugin to sync $auth.user with Vuex store
export default {
  install() {
    // Watch for auth user changes
    Vue.mixin({
      created(this: Vue) {
        if (this.$auth && this.$auth.user) {
          store.dispatch("auth/updateUser", this.$auth.user)
        }
      },
      watch: {
        "$auth.user": {
          handler(newUser) {
            store.dispatch("auth/updateUser", newUser)
          },
          immediate: true,
        },
      },
    })
  },
}
